module.exports = __webpack_public_path__ + "static/media/服务能力.2d361c40.png";